import { render, staticRenderFns } from "./LivestreamAgora.vue?vue&type=template&id=700715ad&"
import script from "./LivestreamAgora.vue?vue&type=script&lang=js&"
export * from "./LivestreamAgora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports